import { defineAsyncActionTypes } from 'store/common/action-helpers';

const prefix = 'graphql/AssignmentDetails';
// FOR ONE GRAPHQL QUERY
export const GET_ASSIGNMENT = defineAsyncActionTypes(`${prefix}/GET_ASSIGNMENT`);

export const FINISH_ASSIGNMENT = defineAsyncActionTypes(`${prefix}/FINISH_ASSIGNMENT`);



// WEBPACK FOOTER //
// ./src/store/graphql/AssignmentDetails/action-types.js